import { Injectable } from '@angular/core'
import { MessageService } from '@openng/optimus-ui/api'
import { ProjectInfo } from '../../environments/environment'
@Injectable({
  providedIn: 'root'
})
export class FuseqService {
  public projectInfo: any
  constructor(private readonly messageService: MessageService) {
    this.projectInfo = ProjectInfo
  }

  getProjectInfo(key: string) {
    return this.projectInfo[key]
  }

  /* formatTimestampToIT (timestamp) {
    const date = moment(timestamp).format('DD/MM/YYYY HH:mm:ss')
    return date.toLowerCase() == 'invalid date' ? '-' : date
  } */

  getBackEndAuthentication() {
    return 'Basic ' + btoa(this.projectInfo.backendAPI.username + ':' + this.projectInfo.backendAPI.password)
  }

  errorAnalizer(error) {
    console.log(error)
    if (error.includes('null value in column "Code" violates not-null constraint')) {
      this.messageService.add({ severity: 'error', detail: 'Name field should not be null' })
    } else if (error.includes('duplicate key value violates unique constraint "_system_PFList_Code"')) {
      this.messageService.add({ severity: 'error', detail: 'PF name already exists' })
    } else if (error.includes('is out of range for type integer')) {
      this.messageService.add({ severity: 'error', detail: 'Port value must be between 0 and 65535' })
    } else if (error.includes('invalid input syntax for type inet')) {
      this.messageService.add({ severity: 'error', detail: 'Invalid IP address' })
    } else if (error.includes('malformed record literal')) {
      this.messageService.add({ severity: 'error', detail: 'Invalid IP address' })
    } else if (error.includes('malformed range literal')) {
      this.messageService.add({ severity: 'error', detail: 'Invalid range' })
    } else if (error.includes('violates check constraint "tufinpredefinedservices_check_tcp_udp')) {
      this.messageService.add({ severity: 'error', detail: 'TCP and UDP illegal values' })
    } else if (error.includes('duplicate key value violates unique constraint "_system_tufinpredefinedservices_code')) {
      this.messageService.add({ severity: 'error', detail: 'Service Name already exists' })
    } else if (error.includes('Class_Code_Check')) {
      this.messageService.add({ severity: 'error', detail: 'It is not possible to insert only white spaces' })
    } else if (error.includes('FWRules_required_fields_check')) {
      this.messageService.add({ severity: 'error', detail: 'Source IP or Destination IP should not be null' })
    } else if (error.includes('duplicate key value violates unique constraint \"_system_servicesnotallowed_unique')) {
      this.messageService.add({ severity: 'error', detail: 'Service Name already exists' })
    } else if (error.includes('violates check constraint')) {
      this.messageService.add({ severity: 'error', detail: 'Please complete the mandatory fields' })
    } else if (error.includes('Error verify')) {
      this.messageService.add({ severity: 'warn', detail: 'Verify failed' })
    } else {
      this.messageService.add({ severity: 'error', detail: error.toString() })
    }
  }

  getDtOptions(type: string) {
    const language = {
      decimal: '',
      emptyTable: 'No data available in table',
      info: 'Showing _START_ to _END_ of _TOTAL_ entries',
      infoEmpty: 'Showing 0 to 0 of 0 entries',
      infoFiltered: '(filtered from _MAX_ total entries)',
      infoPostFix: '',
      thousands: ',',
      lengthMenu: 'Show _MENU_ entries',
      loadingRecords: 'Loading...',
      processing: 'Processing...',
      search: 'Search:',
      zeroRecords: 'No matching records found',
      paginate: {
        first: 'First',
        last: 'Last',
        next: 'Next',
        previous: 'Previous'
      },
      aria: {
        sortAscending: ': activate to sort column ascending',
        sortDescending: ': activate to sort column descending'
      }
    }
    const languageIT = {
      processing: 'Elaborazione...',
      search: 'Cerca:',
      lengthMenu: 'Visualizza _MENU_ elementi',
      info: 'Vista da _START_ a _END_ di _TOTAL_ elementi',
      infoEmpty: 'Vista da 0 a 0 di 0 elementi',
      infoFiltered: '(filtrati da _MAX_ elementi totali)',
      infoPostFix: '',
      loadingRecords: 'Caricamento...',
      zeroRecords: 'La ricerca non ha portato alcun risultato.',
      emptyTable: 'Nessun dato presente nella tabella.',
      paginate: {
        first: 'Primo',
        previous: 'Precedente',
        next: 'Seguente',
        last: 'Ultimo'
      },
      aria: {
        sortAscending: ': attiva per ordinare la colonna in ordine crescente',
        sortDescending: ':attiva per ordinare la colonna in ordine decrescente'
      }
    }
    return type === 'IT' ? languageIT : language
  }
}
